/**
 * Transforms an HTML string containing choices into renderable HTML,
 * replacing raw <img> tags with a styled wrapper + overlay div.
 */
const choiceHTML = (choice: string, backdropClass: string): string => {
  const element = document.createElement("span")
  element.innerHTML = choice
  const images = element.getElementsByTagName("img")
  Array.from(images).forEach((img) => {
    const wrapper = document.createElement("div")
    wrapper.className = "w-full bg-white relative py-4"
    const image = document.createElement("img")
    image.src = img.src
    wrapper.appendChild(image)
    const overlay = document.createElement("div")
    overlay.className = `absolute mix-blend-multiply inset-0 ${backdropClass}`.trim()
    wrapper.appendChild(overlay)
    img.replaceWith(wrapper)
  })
  return element.innerHTML
}

export default choiceHTML
